export default __webpack_public_path__ + "static/media/check.96b01396.png";